import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../core/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  loginAPI =  "/api/lgnfrprtl";
  logoutAPI =  "/api/lgot";
  forgotPasswordAPI =  "/api/frgtpswd";
  resetPasswordAPI =  "/api/rstpwd";

  constructor(private http: HttpClient, private configService: ConfigService) { }

  Login(loginDetail: any) {
    return this.http.post(this.loginAPI, loginDetail);
  }

  Logout() {
    return this.http.post(this.logoutAPI, null);
  }

  ForgotPassword(loginDetail: any) {
    return this.http.post(this.forgotPasswordAPI, loginDetail);
  }

  ResetPassword(passwordDetail: any) {
    return this.http.post(this.resetPasswordAPI, passwordDetail);
  }
}
